import { apiMain } from './apiService';
import { AvailabilitySlot, CreateAvailabilitySlotDTO } from 'types/availabilitySlotTypes';

export const getUserSlots = async (userId: string): Promise<AvailabilitySlot[]> => {
  const { data } = await apiMain.get<AvailabilitySlot[]>('/meetings/v1/availability-slots', {
    params: { user_id: userId },
  });
  return data;
};

export const createSlot = async (slot: CreateAvailabilitySlotDTO): Promise<AvailabilitySlot> => {
  const { data } = await apiMain.post<AvailabilitySlot>('/meetings/v1/availability-slots', slot);
  return data;
};

export const deleteSlot = async (slotId: string, userId: string): Promise<string> => {
  const { data } = await apiMain.delete<string>(`/meetings/v1/availability-slots/${slotId}`, {
    params: { user_id: userId },
  });
  return data;
};

export const updateSlot = async (
  slotId: string,
  slot: Partial<CreateAvailabilitySlotDTO>
): Promise<AvailabilitySlot> => {
  const { data } = await apiMain.patch<AvailabilitySlot>(
    `/meetings/v1/availability-slots/${slotId}`,
    slot
  );
  return data;
};

export const getAvailableSlotsForDate = async (hostId: string, date: string): Promise<any> => {
  const { data } = await apiMain.get(
    `/meetings/v1/availability-slots/users/${hostId}/available-slots`,
    {
      params: { date },
    }
  );
  return data;
};

export interface MeetingRequestDTO {
  requester_id: string;
  host_id: string;
  availability_slot_id: string;
  meeting_date: string; // YYYY-MM-DD
  start_time: string; // HH:mm
  duration_minutes: number;
}

export const createMeetingRequest = async (data: MeetingRequestDTO): Promise<any> => {
  const { data: response } = await apiMain.post('/meetings/v1/meeting-requests', data);
  return response;
};
